// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DisplayText from './DisplayText';

const StyledText = styled(DisplayText)`
  text-transform: uppercase;
`;

type Props = {
  themeColor?: string,
  children: React.Node
};

export function Label({ children, themeColor }: Props) {
  return (
    <StyledText fontSize="12px" themeColor={themeColor || 'labelTextColor'} bold>
      {children}
    </StyledText>
  );
}

Label.propTypes = {
  themeColor: PropTypes.string
};

export default Label;
